import { Children, isValidElement } from 'react'

import styles from 'components/chat-components/AgentMessage.module.css'

import type { ReactElement, ReactNode } from 'react'

export const markdownComponents = {
  p: ({ children }: { children?: ReactNode }) => <p className={styles.markdownParagraph}>{children}</p>,
  h1: ({ children }: { children?: ReactNode }) => <h1 className={styles.markdownHeading}>{children}</h1>,
  h2: ({ children }: { children?: ReactNode }) => <h2 className={styles.markdownHeading}>{children}</h2>,
  h3: ({ children }: { children?: ReactNode }) => <h3 className={styles.markdownHeading}>{children}</h3>,
  h4: ({ children }: { children?: ReactNode }) => <h4 className={styles.markdownHeading}>{children}</h4>,
  ul: ({ children }: { children?: ReactNode }) => <ul className={styles.markdownList}>{children}</ul>,
  ol: ({ children }: { children?: ReactNode }) => <ol className={styles.markdownList}>{children}</ol>,
  li: ({ children }: { children?: ReactNode }) => <li className={styles.markdownListItem}>{children}</li>,
  strong: ({ children }: { children?: ReactNode }) => <strong className={styles.markdownStrong}>{children}</strong>,
  em: ({ children }: { children?: ReactNode }) => <em className={styles.markdownEmphasis}>{children}</em>,
  code: ({ children, className }: { children?: ReactNode; className?: string }) => {
    const isInline = !className
    return isInline ? (
      <code className={styles.markdownInlineCode}>{children}</code>
    ) : (
      <code className={className}>{children}</code>
    )
  },
  pre: ({ children }: { children?: ReactNode }) => <pre className={styles.markdownPre}>{children}</pre>,
  a: ({ href, children }: { href?: string; children?: ReactNode }) => {
    if (!href) {
      return <span>{children}</span>
    }

    return (
      <a className={styles.markdownLink} href={href} target="_blank" rel="noreferrer">
        {children}
      </a>
    )
  },
}

const isThinkingHeadingParagraph = (children?: ReactNode): boolean => {
  const childNodes = Children.toArray(children)

  if (childNodes.length !== 1) {
    return false
  }

  const [onlyChild] = childNodes
  return isValidElement(onlyChild) && onlyChild.type === 'strong'
}

const renderThinkingParagraph = (children?: ReactNode): ReactElement => (
  <p
    className={isThinkingHeadingParagraph(children) ? styles.thinkingMarkdownHeading : styles.thinkingMarkdownParagraph}
  >
    {children}
  </p>
)

export const thinkingMarkdownComponents = {
  ...markdownComponents,
  p: ({ children }: { children?: ReactNode }) => renderThinkingParagraph(children),
  h1: ({ children }: { children?: ReactNode }) => renderThinkingParagraph(children),
  h2: ({ children }: { children?: ReactNode }) => renderThinkingParagraph(children),
  h3: ({ children }: { children?: ReactNode }) => renderThinkingParagraph(children),
  h4: ({ children }: { children?: ReactNode }) => renderThinkingParagraph(children),
  strong: ({ children }: { children?: ReactNode }) => (
    <strong className={styles.thinkingMarkdownStrong}>{children}</strong>
  ),
}
